import state from './userdashboard.state'
import mutations from './userdashboard.mutations'
import actions from './userdashboard.actions'

export default {
  state,
  mutations,
  actions
}
